export { default as ToggleGroupControlOptionBase } from './component';